import classNames from 'classnames';
import { haltClickEventPropagation } from '@lib/events';
import React from 'react';
import { ConfirmDelete, ConfirmDeleteProps } from './ConfirmDelete';
import { DeleteFilled, DeleteOutlined } from '@ant-design/icons';

export interface ConfirmDeleteIconProps extends ConfirmDeleteProps {
	iconClassName?: string;
	type?: 'filled' | 'outline';
}

export const ConfirmDeleteIcon: React.FC<ConfirmDeleteIconProps> = ({ iconClassName, type = 'filled', ...rest }) =>
	<ConfirmDelete { ...rest }>
		{ type === 'filled' ?
			<DeleteFilled
				className={ classNames('delete-button', iconClassName) }
				onClick={ haltClickEventPropagation } />		 :
			<DeleteOutlined
				className={ classNames('delete-button', iconClassName) }
				onClick={ haltClickEventPropagation } /> }
	</ConfirmDelete>;

